<template>
	<div class="more-info">
		<user-centter-temp class="selector-temp" :item-category="otherInfoCategory" :active-index="activeIndex"
			@change-active-index="changeActiveIndex">
			<div class="content">
				<!-- 商品详情 -->
				<div class="product-introduction" v-show="activeIndex == 0">
					<div v-html="decodedRichText" class="detail-html"></div>
				</div>
				<!-- 评价 -->
				<div class="product-comment" v-show="activeIndex == 1">
					<div class="tags">
						<div v-for="(tag, index) in commentTags" :key="index"
							:class="commentIndex == tag.code ? 'commmentPitch' : ''" @click="onEvaluate(tag)">
							{{ language == 'en_US' ? tag.code : tag.name }} <span v-if="tag.num > 0">{{ tag.num }}</span>
						</div>
					</div>
					<div v-for="(item, index) in evaluate_list" :key="index" class="comment_item"
						v-if="evaluate_list.length">
						<div class="flex">
							<img :src="item.user_avatar" alt="" class="head_img">
							<div>
								<p class="flex">
									<span style="margin-right: 12px;">
										{{ item.is_anonymous ? $t('匿名者') : item.user_nickname }}
									</span>
									<el-rate v-model="item.level" disabled size="large" />
								</p>
								<p class="text-999">{{ item.create_time }}</p>
							</div>
						</div>
						<div style="margin-top: 12px;">
							{{ item.content }}
						</div>
						<!-- 图片 -->
						<div>
							<el-image v-for="(e, i) in item.imgList" :key="i" :src="e" :preview-src-list="item.imgList"
								:initial-index="i" fit="cover" class="com_img" />
						</div>
					</div>
					<el-empty :description="$t('暂无数据')" v-if="!evaluate_list.length"></el-empty>
				</div>
			</div>
		</user-centter-temp>
	</div>
</template>

<style scoped>
div .user-center-temp {
	padding: 0;
}

div /deep/ .user-center-temp .content {
	/* width: 100px; */
	width: 100%;
}
</style>

<script>
import UserCenterTemp from '@/components/UserCenterTemp'
import he from 'he';
import { evaluateList, evaluateType } from '@/api/user';
import { Language } from "@/utils/auth";

export default {
	name: 'MoreInfo',
	components: {
		'user-centter-temp': UserCenterTemp,
	},
	data() {
		return {
			value1: 2,
			otherInfoCategory: [
				{
					index: 0,
					item: this.$t('图文详情'),
				},
				{
					index: 1,
					item: this.$t('用户评价'),
				},

			],
			activeIndex: 0,
			commentTags: [],
			commentIndex: '',
			detail: {},//商品详情
			decodedRichText: '',//富文本
			evaluate_list: [],//评价列表
			language: ''
		}
	},
	created() {
		// console.log(this.detail);
		this.language = Language()
	},
	computed: {

	},
	methods: {
		/**评价类型 */
		onEvaluateType() {
			evaluateType({ product_id: this.detail.id }).then(res => {
				// console.log(res.data);
				this.commentTags = res.data
				this.commentIndex = this.commentTags[0].code
				this.onEvaluateList()
			})
		},
		/**点击评价类型 */
		onEvaluate(e) {
			this.commentIndex = e.code
			this.onEvaluateList()
		},
		/**商品评价 */
		onEvaluateList() {
			let data = {
				product_id: this.detail.id,
				type: this.commentIndex
			}
			evaluateList(data).then(res => {
				this.evaluate_list = res.data.data
				// imgList
				let evaluate_list = this.evaluate_list
				evaluate_list.forEach(e => {
					e.imgList = e.images ? e.images.split(',').filter(Boolean) : []
				})
			})
		},
		/**商品详情 */
		onDetail(e) {
			this.detail = e
			this.decodedRichText = he.decode(e.intro)
			this.onEvaluateType()
		},
		// 改变展示项目的index
		changeActiveIndex: function (index) {
			this.activeIndex = index;
		},
	},
};
</script>

<style scoped>
.more-info {
	/* width: 960px; */
	width: 100%;
	position: relative;
}

/* 商品介绍 */
.more-info .selector-temp .content .product-introduction p:first-child {
	line-height: 60px;
}

.more-info .selector-temp .content .product-introduction p .brand {
	color: #1234ab;
}

.more-info .selector-temp .content .product-introduction p .brand:hover {
	cursor: pointer;
	color: #ef1234;
}

.more-info .selector-temp .content .product-introduction p:nth-child(n+2) {
	line-height: 30px;
}

.more-info .selector-temp .content .product-introduction p span {
	display: inline-block;
	width: 45%;
	font-size: 12px;
	padding-left: 20px;
}

.detail-html {
	margin-top: 24px;
	overflow: hidden;
	text-align: center;
}

.detail-html /deep/ img,
.detail-html /deep/ video {
	max-width: 100%;
	height: auto;
	display: block;
	margin-left: auto;
	margin-right: auto;
}

.detail-html /deep/ table {
	max-width: 100%;
	height: auto;
	margin-left: auto;
	margin-right: auto;
}

.more-info /deep/ .user-center-temp .content {
	width: 100%;
}

.more-info /deep/ .user-center-temp .content .header-nav {
	margin-left: 0;
	border-bottom: 1px solid #EEEEEE;
}

.more-info /deep/ .user-center-temp .content .header-nav li {
	border-bottom: none;
}

.more-info /deep/ .user-center-temp .content .header-nav li.active {
	border-bottom: 4px solid #000000;
	margin-bottom: -1px;
}

/* 商品评价 */
.more-info .selector-temp .content .product-comment>div {
	overflow: hidden;
}

.more-info .selector-temp .content .product-comment .tags {
	/* margin-left: 10px; */
	/* width: 560px; */
	padding: 24px 0 32px;
	display: flex;
	flex-wrap: wrap;
}

.more-info .selector-temp .content .product-comment .tags div {
	float: left;
	padding: 8px 16px;
	color: #333333;
	font-size: 14px;
	margin: 0 24px 6px 0;
	border-radius: 4px;
	cursor: pointer;
	background: #F8F8F8;
}

.more-info .selector-temp .content .product-comment .tags .commmentPitch {
	color: #FFFFFF;
	border: 0;
	background-color: #333333;
}

.comment_item {
	margin-bottom: 24px;
}

.comment_item .head_img {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	margin-right: 10px;
}

.comment_item .com_img {
	width: 180px;
	height: 180px;
	margin-right: 10px;
	margin-top: 8px;
	object-fit: cover;
	border-radius: 4px;
}

@media (max-width: 767px) {
	.more-info /deep/ .user-center-temp {
		padding: 12px 0 0;
	}

	.more-info /deep/ .user-center-temp .content {
		width: 100%;
	}

	.more-info /deep/ .user-center-temp .content .header-nav {
		margin-left: 0;
	}

	.detail-html {
		margin-top: 12px;
		overflow: hidden;
	}

	.detail-html /deep/ img,
	.detail-html /deep/ video,
	.detail-html /deep/ table {
		max-width: 100% !important;
		height: auto !important;
	}

	.comment_item .com_img {
		width: 72px;
		height: 72px;
		margin-right: 6px;
		margin-top: 8px;
	}

	.more-info .selector-temp .content .product-comment .tags {
		padding: 12px 0 16px;
	}

	.more-info .selector-temp .content .product-comment .tags div {
		padding: 6px 10px;
		margin: 0 8px 8px 0;
		font-size: 12px;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/goods/components/MoreInfo.vue